<template>
  <!-- Header section start -->
  <header>
    <div class="container">
      <nav class="navbar navbar-expand-lg p-0">
        <!-- Left Side (e.g. logo or menu) -->
        <!-- <div class="d-flex align-items-center me-auto">
          <a
            target="_blank"
            href="#!"
            data-bs-toggle="modal"
            data-bs-target="#location"
            class="btn btn-sm theme-btn mt-0"
          >
            <i class="ri-map-pin-line"></i> {{ $t("location") }}
          </a>
        </div> -->

        <div class="d-flex align-items-end ms-auto">
          <LanguageSwitcher />
        </div>

        <div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasNavbar">
          <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasNavbarLabel">Menu</h5>
            <button class="navbar-toggler btn-close" id="offcanvas-close"></button>
          </div>
          <div class="offcanvas-body">
            <ul class="navbar-nav justify-content-center flex-grow-1">
              <li class="nav-item">
                <router-link to="/home" class="nav-link" exact-active-class="active">
                  <span>{{ $t("map") }}</span></router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  to="/order_list"
                  class="nav-link"
                  exact-active-class="active"
                >
                  <span>{{ $t("order list") }}</span></router-link
                >
              </li>
            </ul>
          </div>
        </div>
        <!-- Right Side Icons -->
        <!-- <div class="d-flex align-items-center ms-auto gap-2"></div> -->

        <div class="nav-option order-md-2">
          <div class="profile-part dropdown-button order-md-2">
            <img
              :src="currentImageUrl || defaultImage"
              class="img-fluid profile-pic"
              alt="profile"
            />
            <div>
              <h5 class="fw-medium">{{ user?.name || $t("guest") }}</h5>

              <h6 class="fw-normal">{{ $t("welcome from axefood!") }}</h6>
            </div>
            <div class="onhover-box onhover-sm">
              <ul class="menu-list">
                <li>
                  <router-link to="/account_edit" class="dropdown-item">{{
                    $t("profile edit")
                  }}</router-link>
                </li>
                <li>
                  <router-link to="/order_list" class="dropdown-item">{{
                    $t("orders")
                  }}</router-link>
                </li>

                <li>
                  <router-link class="dropdown-item" to="/help_center">{{
                    $t("help center")
                  }}</router-link>
                </li>
              </ul>
              <div class="bottom-btn">
                <a @click="handleLogout" class="theme-color fw-medium d-flex"
                  ><i class="ri-login-box-line me-2"></i>{{ $t("logout") }}</a
                >
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  </header>
  <!-- Header Section end -->
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import axios from "axios";
import { LOCAL_STORAGE_KEYS } from "@/utils/constants";
import { getUser } from "@/utils/permission";
import LanguageSwitcher from "@/components/LanguageSwitcher.vue";

const user = getUser();
console.log(user);
const router = useRouter();
const defaultImage = "https://api.axefood.org/default/profile_default.png";
const currentImageUrl = ref("");
if (user && user.image) {
  currentImageUrl.value = `https://api.axefood.org/storage/${user.image}`;
}
const handleLogout = async () => {
  try {
    localStorage.removeItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN_KEY);
    localStorage.removeItem(LOCAL_STORAGE_KEYS.AUTH_USER_INFO);
    delete axios.defaults.headers.common["Authorization"];

    // Redirect to login page using path instead of name
    router.push("/"); // Changed from { name: '/' } to just '/'
  } catch (error) {
    console.error("Logout error:", error);
    localStorage.removeItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN_KEY);
    delete axios.defaults.headers.common["Authorization"];
    router.push("/"); // Changed here as well
  }
};
</script>
<style scoped>
/* Hide header only on mobile (≤ 768px) */
/* @media (max-width: 768px) {
  header {
    display: none !important;
  }
} */
</style>
